import type { IStrapiImage } from '~/types/strapiImage';

const isObject = (item: any) => item && typeof item === 'object' && Object.keys(item).length;
const isImage = (item: any) =>
  (item?.width || item?.width === null) && (item?.height || item?.height === null);

/**
 * Method for parse strapi image interface and replace cdn url if needed
 */
export const strapiFileParser = (image: IStrapiImage) => {
  const strapiImgUrl = `https://strapi-7bit-bucket.s3.us-west-1.amazonaws.com/`;
  const newUrl = `/cdn/`;

  if (process.env.S3_ORIGINAL_HOST !== 'true') {
    image.url = image.url.replace(strapiImgUrl, newUrl);
  }

  return image;
};

export const parseImagesInObject = (object: any) => {
  if (!object) {
    return object;
  }

  Object.keys(object).forEach((key) => {
    if (isImage(object[key])) {
      object[key] = strapiFileParser(object[key]);
    }
  });

  return object;
};

export const parseImagesInArray = (array: any[]) => {
  return array && array.map((item) => parseImagesInObject(item));
};

const parseStrapiImages = (item: any) => {
  let parcedItem = item;

  if (Array.isArray(item)) {
    parcedItem = parseImagesInArray(item);
  } else if (isImage(item)) {
    parcedItem = strapiFileParser(item);
  } else if (isObject(item)) {
    parcedItem = parseImagesInObject(item);
  }

  return parcedItem;
};

export const parseItemInCollection = (item: any) => {
  const parsedValue = {} as any;

  if (item) {
    Object.keys(item).forEach((key) => {
      const parsedData = parseStrapiImages(item[key]);

      if (parsedData !== null && parsedData !== undefined) {
        parsedValue[key] = parsedData;
      }
    });
  }

  return parsedValue;
};

export const parseCollectionData = <T = any>(data: any[]): T[] => {
  return data.map((item: any) => parseItemInCollection(item));
};

export const assignDataToFields = (fields: any, data: any) => {
  Object.keys(fields).forEach((key) => {
    const parsedData = parseStrapiImages(data[key]);

    if (parsedData !== null && parsedData !== undefined) {
      fields[key] = parsedData;
    }
  });
};

export const createPopulateString = (fields: string[], zones?: string[]) => {
  let string = '';
  fields.forEach(
    (field, index) => (string = string + `${index === 0 ? '' : '&'}populate[${index}]=${field}`)
  );
  if (zones) {
    zones.forEach(
      (field, index) =>
        (string = string + `${index === 0 && !string ? '' : '&'}populate[${field}][populate]=*`)
    );
  }

  return string;
};
